export const STATE_ROOT_KEY = 'password';

export const INITIAL_STATE = {
  rules: undefined,
  error: undefined,
  resetToken: undefined,
  saved: false,
  resetIsLoading: false,
  resetLinkIsLoading: false,
  resetLinkSent: false,
  forgotPasswordMessage: null,
};
